import { redirect, RouteObject } from 'react-router';
import PermissionGuard from '../gate/PermissionGuard';
import PremiumGuard from '../gate/PremiumGuard';
import { PERMISSIONS } from '@/shared/constants';
import { ALERT_TYPE_PERMISSIONS } from '@/features/alerts/constants';

export const toolsRoutes: RouteObject[] = [
	{
		path: 'tools',
		children: [
			{
				lazy: async () => {
					const { default: Component } = await import('../pages/ToolsPage');
					return { Component };
				},
				children: [
					{
						index: true,
						loader: () => redirect('reports'),
					},
					{
						path: 'reports',
						lazy: async () => {
							const { default: Page } = await import('@/features/reports/pages/ReportsPage');
							return {
								Component: () => (
									<PermissionGuard permission={PERMISSIONS.REPORT_READ}>
										<Page />
									</PermissionGuard>
								),
							};
						},
						children: [
							{
								index: true,
								lazy: async () => {
									const { default: Component } = await import(
										'@/features/reports/pages/ReportsIndexPage'
									);
									return { Component };
								},
							},
							{
								path: 'templates',
								lazy: async () => {
									const { default: Page } = await import(
										'@/features/reports/pages/ReportsScheduledPage'
									);
									return {
										Component: () => (
											<PermissionGuard permission={PERMISSIONS.REPORT_SCHEDULE}>
												<Page />
											</PermissionGuard>
										),
									};
								},
							},
						],
					},
					{
						path: 'reports/create',
						lazy: async () => {
							const { default: Page } = await import('@/features/reports/pages/ReportsCreatePage');
							return {
								Component: () => (
									<PermissionGuard permission={PERMISSIONS.REPORT_CREATE}>
										<Page />
									</PermissionGuard>
								),
							};
						},
					},

					{
						path: 'reports/templates/:templateId',
						lazy: async () => {
							const { default: Page } = await import(
								'@/features/reports/pages/ReportsScheduledDetailsPage'
							);
							return {
								Component: () => (
									<PermissionGuard permission={PERMISSIONS.REPORT_SCHEDULE}>
										<Page />
									</PermissionGuard>
								),
							};
						},
					},
					{
						path: 'alerts',
						lazy: async () => {
							const { default: Page } = await import('@/features/alerts/pages/AlertsPage');
							return {
								Component: () => (
									<PremiumGuard
										permission={PERMISSIONS.ALERTS_READ}
										buyPermission={PERMISSIONS.ALERTS_BUY}
										// alerts:read may not arrive yet; AddonGate shows the teaser then
										allowMissingPermission
									>
										<Page />
									</PremiumGuard>
								),
							};
						},
						children: [
							{
								lazy: async () => {
									const { default: Component } = await import(
										'@/features/alerts/pages/AlertsIndexPage'
									);
									return { Component };
								},
								children: [
									{
										index: true,
										loader: () => redirect('messages'),
									},
									{
										path: 'messages',
										lazy: async () => {
											const { default: Component } = await import(
												'@/features/alerts/pages/AlertsMessagesPage'
											);
											return { Component };
										},
									},
									{
										path: 'configurations',
										lazy: async () => {
											const { default: Component } = await import(
												'@/features/alerts/pages/AlertsConfigsPage'
											);
											return { Component };
										},
										children: [
											{
												index: true,
												lazy: async () => {
													const { default: Component } = await import(
														'@/features/alerts/pages/AlertsConfigIndexPage'
													);
													return { Component };
												},
											},
										],
									},
								],
							},
							{
								path: 'configurations/create',
								lazy: async () => {
									const { default: Page } = await import(
										'@/features/alerts/pages/AlertsConfigCreatePage'
									);
									return {
										Component: () => (
											<PermissionGuard permission={PERMISSIONS.ALERTS_CREATE}>
												<PermissionGuard
													permission={ALERT_TYPE_PERMISSIONS}
													mode='any'
												>
													<Page />
												</PermissionGuard>
											</PermissionGuard>
										),
									};
								},
							},
							{
								path: 'configurations/:configId',
								lazy: async () => {
									const { default: Component } = await import(
										'@/features/alerts/pages/AlertConfigDetailsPage'
									);
									return { Component };
								},
								children: [
									{
										index: true,
										loader: () => redirect('info'),
									},
									{
										path: 'info',
										lazy: async () => {
											const { default: Component } = await import(
												'@/features/alerts/pages/AlertConfigInfoPage'
											);
											return { Component };
										},
									},
									{
										path: 'history',
										lazy: async () => {
											const { default: Component } = await import(
												'@/features/alerts/pages/AlertConfigHisotryPage'
											);
											return { Component };
										},
									},
								],
							},
						],
					},
				],
			},
		],
	},
];
